import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetLookUpDropdownListQuery } from '../../api/endpoints/lookup';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Alınan Teminatlar ekranındaki "İade edildi mi?" seçimi.
 * `CollateralTypeDropdown.jsx` ile aynı desen: paylaşılan lookup ucu kullanılır
 * (`v1/lookup/get?GroupCode=XXBOS_AFTER_YES_NO`). `isReturned` backend'de STRING olarak
 * saklanıyor ("1" = Evet, "2" = Hayır — bkz. docs), bu yüzden `CollateralTypeDropdown`'ın
 * aksine `code` değeri `Number()` ile çevrilmeden, lookup'tan geldiği gibi string olarak kullanılır.
 */
const CollateralIsReturnedDropdown = ({ value, onChange, className, placeholder, disabled = false }) => {
    const { getCurrentLanguageId } = useLanguage();

    const { data: raw = [], isLoading } = useGetLookUpDropdownListQuery({
        GroupCode: 'XXBOS_AFTER_YES_NO',
        LanguageId: getCurrentLanguageId() ?? 2
    });

    const options = useMemo(() => {
        const items = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
        return items
            .filter((item) => item.code != null)
            .map((item) => ({
                label: item.translatedText || String(item.code),
                value: String(item.code)
            }));
    }, [raw]);

    return (
        <Dropdown
            value={value ?? null}
            onChange={(e) => onChange?.(e.value)}
            options={options}
            optionLabel="label"
            optionValue="value"
            className={className}
            placeholder={placeholder}
            disabled={disabled || isLoading}
            loading={isLoading}
            appendTo={document.body}
        />
    );
};

export default CollateralIsReturnedDropdown;
